export const constraints = {
    nome: {
        presence: {
            message: "é obrigatório."
        }
    },
    cidade: {
        presence: {
            message: "é obrigatório."
        }
    },
    email: {
        presence: {
            message: "é obrigatório."
        }
    },
    telefone: {
        presence: {
            message: "é obrigatório."
        }
    },
    ddd: {
        presence: {
            message: "é obrigatório."
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-soliciteaqui/constraints.js